import { Flex, Form } from 'antd'
import OldNum from '../../../../form-items/old-num'
import PolymerField from '../../../../form-items/polymer'
import AddFormButton from '../../../../form-items/add-form-button'
import { FC } from 'react'
import { useCreateFormMutation } from '../../../../../../../../store/api/forms-api'
import {
    formSetsApi,
    useCreateFormSetMutation,
} from '../../../../../../../../store/api/form-sets-api'
import connect from '../../../../../../../../helpers/api/connect'
import FormSet from '../../../../../../../../types/api/form-set'
import { Polymer } from '../../../../../../../../types/api/form'
import { useAppDispatch } from '../../../../../../../../store/store'
import { UniversalColorFormFields } from '../../../../../../../../components/universal-color-picker'

interface FormValues {
    color: string
    colorName: string
    oldNum?: string
    polymer?: Polymer
}

interface CreationFormProps {
    formSet?: FormSet
    onCreatedFormSet: (formSet: FormSet) => void
}

export const CreationForm: FC<CreationFormProps> = ({ formSet, onCreatedFormSet }) => {
    const formSetFromProps = formSet
    const dispatch = useAppDispatch()
    const [form] = Form.useForm<FormValues>()
    const [createFormSet] = useCreateFormSetMutation()
    const [createForm] = useCreateFormMutation()

    const getFormSet = async () => {
        if (formSet) return formSet

        // Создает новый набор, если не было
        const response = await createFormSet({
            data: {},
        })

        return response.data?.data
    }

    const onAddForm = async () => {
        try {
            await form.validateFields()
        } catch {
            return
        }

        const values = form.getFieldsValue()
        const formSet = await getFormSet()

        // Выходим, если нету или не создался
        if (!formSet) return

        // Создаем форму и сразу кладем в набор
        const res = await createForm({
            data: {
                color: values.color,
                colorName: values.colorName,
                num: values.oldNum,
                form_set: connect(formSet),
                inStock: values.oldNum ? true : false,
                ...(values.polymer ? { polymer: values.polymer } : {}),
            },
        })

        form.resetFields()

        if (res.data?.data) {
            dispatch(formSetsApi.util.invalidateTags(['FormSet']))
        }

        // Если мы только что создали набор, то вызываем колбэк
        if (!formSetFromProps && formSet) {
            onCreatedFormSet(formSet)
        }
    }

    return (
        <Form form={form} layout={'vertical'}>
            <Flex gap={12} align='flex-start' wrap='wrap'>
                <UniversalColorFormFields fields={{ name: 'colorName', hex: 'color' }} />
                <OldNum />
                <PolymerField />
                <AddFormButton onClick={onAddForm} />
            </Flex>
        </Form>
    )
}
